import { RowTable } from "@/components/table/UITableProps";
import { Direccion, FileInfo, RepresentanteLegal } from "@/services/common/expediente-types";
import React, { createContext, useContext, useEffect, useState } from "react";

export interface Expediente {
  idProcess?: string;
  documentToValidate?: FileInfo;
  idDocument: string;
  pertenencia?: string;
  tipoEsperado?: string;
  address?: Direccion;
  listFiles?: RowTable[];
  representative?: RepresentanteLegal;
}

const initialState: Expediente = Object.freeze({
  idProcess: "",
  idDocument: "",
});

interface ExpedienteContextType {
  expediente: Expediente;
  setExpediente: React.Dispatch<React.SetStateAction<Expediente>>;
  idExpediente: string;
  setIdExpediente: React.Dispatch<React.SetStateAction<string>>;
  cleanExpediente: () => void;
}

const ExpedienteContext = createContext<ExpedienteContextType>({
  expediente: initialState,
  idExpediente: "",
  setExpediente: () => { },
  setIdExpediente: () => { },
  cleanExpediente: () => { },
});

const isEmptyExpediente = (expedient: Expediente) => {
  return expedient.idProcess === "";
};

const ExpedienteProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [expediente, setExpediente] = useState<Expediente>(JSON.parse(JSON.stringify(initialState)));
  const [idExpediente, setIdExpediente] = useState<string>("");
  const [wasCleaned, setWasCleaned] = useState<boolean>(false);

  const cleanExpediente = () => {
    console.log("Cleaning expedienteContext");
    if (idExpediente) {
      localStorage.setItem(`expediente-${idExpediente}`, JSON.stringify(initialState));
    }
    setExpediente(initialState); // También limpia el state local
    setIdExpediente("");
    setWasCleaned(true);
  };

  useEffect(() => {
    if (isEmptyExpediente(expediente) || idExpediente === "") return;
    localStorage.setItem(`expediente-${idExpediente}`, JSON.stringify(expediente));
  }, [expediente, idExpediente]);

  useEffect(() => {
    if (idExpediente === "" || wasCleaned) {
      if (wasCleaned) {
        setWasCleaned(false); // Resetear la bandera después de evitar la carga
      }
      return;
    }

    const storedData = localStorage.getItem(`expediente-${idExpediente}`);
    if (storedData && storedData !== "undefined" && storedData !== "null") {
      const dataExpediente = JSON.parse(storedData);
      setExpediente(dataExpediente);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idExpediente]);

  return <ExpedienteContext.Provider value={{ expediente, setExpediente, idExpediente, setIdExpediente, cleanExpediente, }} >{children}</ExpedienteContext.Provider>;
};

const useExpedienteContext = () => useContext(ExpedienteContext);

export { ExpedienteProvider, ExpedienteContext, useExpedienteContext };
